
export function drawTankTree(element, canvasStyle) {

    const CANVAS_SELECTOR = "." + element.canvasClass;
    const ITEM_SELECTOR = "." + element.itemClass;
    const padding = canvasStyle.padding ? canvasStyle.padding : 0;

    let context;

    let drawPolyline = function(coords){
        context.beginPath();
        context.moveTo(coords[0][0],coords[0][1]);
        for (let i=1; i< coords.length; i++) {
            context.lineTo(coords[i][0],coords[i][1]);
        }
        context.stroke();
    };

    let drawBranches = function(el, children) {
        const branches = children.length;

        switch(branches) {
            case 1:
                if (el.y === children[0].y) {
                    drawPolyline([[el.x + el.w/2 + padding, el.y], [children[0].x - children[0].w/2 - padding , children[0].y]]);
                } else if (el.x === children[0].x) {
                    drawPolyline([[el.x, el.y + el.h/2 + padding], [children[0].x , children[0].y - children[0].h/2 - padding]]);
                } else {
                    const half_point_x = Math.floor(el.x + (children[0].x - el.x)/2);
                    drawPolyline([[el.x + el.w/2 + padding, el.y], [half_point_x , el.y],
                                 [half_point_x, children[0].y], [children[0].x - children[0].w/2 - padding , children[0].y]]);
                }
                break;
            case 0:
                break;
            default:
                let y_children = children.map(function(e){ return e.y });
                if (new Set(y_children).size === 1) { // vertical
                    let x_children = children.map(function(e){return e.x}),
                        x_max = Math.max.apply(Math, x_children),
                        x_min = Math.min.apply(Math, x_children),
                        half_point_y = Math.floor(el.y + (children[0].y - children[0].h/2 - el.y - el.h/2)/2 + el.h/2);

                    drawPolyline([[el.x, el.y + el.h/2 + padding], [el.x, half_point_y],
                                 [x_min, half_point_y], [x_min, children[0].y - children[0].h/2 - padding]]);
                    drawPolyline([[el.x, half_point_y], [x_max, half_point_y],
                                  [x_max, children[0].y - children[0].h/2 - padding]]);

                    for (let i=0; i< branches; i++) {
                        if ((children[i].x !== x_min) && (children[i].x !== x_max))
                            drawPolyline([[children[i].x, half_point_y],
                                          [children[i].x, children[i].y - children[i].h/2 - padding]]);
                    }
                } else { // horizontal
                    let y_max = Math.max.apply(Math, y_children),
                        y_min = Math.min.apply(Math, y_children),
                        half_point_x = Math.floor(el.x + (children[0].x - children[0].w/2 - el.x - el.w/2)/2 + el.w/2);

                    drawPolyline([[el.x + el.w/2 + padding, el.y], [half_point_x, el.y],
                                 [half_point_x, y_min], [children[0].x - children[0].w/2 - padding, y_min]]);
                    drawPolyline([[half_point_x, el.y], [half_point_x, y_max], [
                                   children[0].x - children[0].w/2 - padding, y_max]]);

                    for (let i=0; i< branches; i++) {
                        if ((children[i].y !== y_min) && (children[i].y !== y_max))
                            drawPolyline([[half_point_x, children[i].y],
                                        [children[i].x - children[i].w/2 - padding, children[i].y]]);
                    }
                }
                break;
        }
    };

    let getPositionCoord = function(el, parent_pos) {
        let item_pos = el.getBoundingClientRect();
        let x, y;

        x = item_pos.left - parent_pos.left + (item_pos.width/2);
        y = item_pos.bottom - parent_pos.top - (item_pos.height)/2;

        return {x: Math.floor(x), y: Math.floor(y), w: Math.floor(item_pos.width), h: item_pos.height};
    };

    let drawTree = function(c) {
        const parent_coords = c.parentElement.getBoundingClientRect();

        c.width = c.parentElement.offsetWidth;
        c.height = c.parentElement.offsetHeight;

        context = c.getContext("2d");
        context.strokeStyle = canvasStyle.strokeColor;

        $(ITEM_SELECTOR).each(function() {
            let mapping = $(this).data("mapping");
            let item_pos = getPositionCoord(this, parent_coords, false);

            if (mapping) {
                let children = String(mapping).split(",").map(function(x) {return parseInt(x)});
                let children_pos = [];

                for (let i=0; i< children.length; i++) {
                    let child_index = children[i];
                    let child_pos = getPositionCoord($(`${ITEM_SELECTOR}[data-value='${child_index}']`)[0], parent_coords);
                    children_pos.push(child_pos);
                }

                drawBranches(item_pos, children_pos);
            }
        });
    };
    const onReady = $element => (
        new Promise((resolve) => {
            const waitForElement = () => {
                if ($element) {
                    resolve($element);
                } else {
                    window.requestAnimationFrame(waitForElement);
                }
            };
            waitForElement();
        })
    );

    onReady($(CANVAS_SELECTOR)).then(() => {
        let canvas;
        const $canvasSelector = $(CANVAS_SELECTOR);

        let context;

        if ($canvasSelector.find('canvas').length < 1) {
            canvas =  $('<canvas/>');
            $canvasSelector.append(canvas);
        } else {
            canvas = $canvasSelector.find('canvas');
        }
        context = canvas.get(0);
        context.style.position = canvasStyle.position ? canvasStyle.pointerEvents : "absolute";
        context.style.pointerEvents = canvasStyle.pointerEvents ? canvasStyle.pointerEvents : "none";
        context.style.top = canvasStyle.top ? canvasStyle.top : "0";
        context.style.left = canvasStyle.left ? canvasStyle.left : "0";

        drawTree(context);

        const onResizeAct = _.debounce(function() {
            drawTree(context);
        }, 250);

        $(window).on("load resize", onResizeAct);
    })
}
